// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__UoLrj","paramInput":"JobSimulator_paramInput__2jc24","input":"JobSimulator_input__15EaN"};